import React from "react"
import SearchResult from "../components/pages/search-result"

const SearchResultPage = (props) => <SearchResult {...props} />

export default SearchResultPage